import React from "react"
import { useShopify } from "../../../hooks/useShopify"

import { useSwatch } from "../../../hooks/useSwatch"

export const withSelectorGrid = Component => ({ name = "SelectorGrid", size, colours, selectedProduct, inline, ...props }) => {
  const { decodeProductId } = useShopify()
  const { getSwatchByProduct } = useSwatch()

  const productColours =
    colours?.map(product => ({
      ...product,
      id: product?.shopify?.id || decodeProductId(product?.id),
      handle: product?.shopify?.handle || product?.handle,
      image: product?.image || product?.images?.edges?.[0]?.node?.transformedSrc,
    })) || []

  const orderedProductColours = inline
    ? [productColours?.find(product => product.id === selectedProduct), ...productColours?.filter(product => product.id !== selectedProduct)].filter(
        product => product
      ) || []
    : productColours

  Component.displayName = name
  return (
    <Component
      {...props}
      size={size}
      colours={orderedProductColours}
      selectedProduct={selectedProduct}
      getSwatch={getSwatchByProduct}
      inline={inline}
    />
  )
}
